import React from 'react';

const Image = ({
  z,
  image,
  title = "Imagem",
  basePath = `${process.env.PUBLIC_URL}/assets/images/`,
  loading = "",
  fetchpriority = "",
  width = "",
  height = "",
  webp = false,
  className = "",
  style = {}
}) => {
  if (!image || typeof image !== "string") return null;

  const extension = image.endsWith(".png") ? "png" : "jpg";
  const imagePath = `${basePath}${image.replace(/\.(jpg|png)$/, "")}`;

  const imgProps = {};
  if (loading) imgProps.loading = loading;
  if (fetchpriority) imgProps.fetchpriority = fetchpriority;
  if (width) imgProps.width = width;
  if (height) imgProps.height = height;

  // `webp`: só para imagens com .webp gerado por scripts/convert_webp.py.
  const webpSources = webp && (
    <>
      <source type="image/webp" media="(min-width: 1366px)" srcSet={`${imagePath}@2x.webp`} />
      <source type="image/webp" media="(min-width: 1024px)" srcSet={`${imagePath}.webp`} />
      <source type="image/webp" srcSet={`${imagePath}-mobile.webp`} />
    </>
  );

  return (
    <picture>
      {webpSources}
      <source media="(min-width: 1366px)" srcSet={`${imagePath}@2x.${extension}`} />
      <source media="(min-width: 1024px)" srcSet={`${imagePath}.${extension}`} />
      <source srcSet={`${imagePath}-mobile.${extension}`} />
      <img
        src={`${imagePath}.${extension}`}
        alt={title}
        className={className}
        {...imgProps}
        style={{ zIndex: z, ...style }}
      />
    </picture>
  );
};

export default Image;
